import React from 'react';
import { useSDMRouterContext } from '@ldp/sdm-contexts';
import { useRedirectLink } from '../../utils';
import { Footer } from '@ldp-web/component-library/ui/organisms/footer';
import { FooterData } from '@ldp-web/component-library/ui/organisms/footer/footer-types'; // TODO: export footerData type from component to use here
import { staticFooterData } from './__mocks__/static-footer';
import { useSettingsContext } from '@ldp/common-contexts';
import { SDMLanguageType } from '@ldp/common-types';

export interface IFooterProps {
  contentId?: string;
  componentId?: string;
}
/** renders footer layout */
export const FooterComponent: React.FC<IFooterProps> = () => {
  const IS_SSR = typeof window === 'undefined';
  const settings = useSettingsContext();
  const router = useSDMRouterContext();
  const redirectToPage = useRedirectLink(router);
  const { hostname } = !IS_SSR ? window.location : { hostname: '' };
  const banner = IS_SSR
    ? 'shoppersdrugmart'
    : hostname?.includes('pharmaprix') || hostname?.includes('phx')
    ? 'pharmaprix'
    : 'shoppersdrugmart';
  const locale = settings.locale as SDMLanguageType;
  const isQuebec = settings.isQuebec as boolean;
  const footerData = staticFooterData[banner][locale] as unknown as FooterData;

  return (
    <>
      <Footer
        footerData={footerData}
        clickHandler={redirectToPage}
        locale={locale as any}
        isQuebec={isQuebec as boolean}
      />
    </>
  );
};

export default FooterComponent;
